import Layout from "@/HOC";
import { Breadcrumb } from "antd";
import React from "react";
import styles from "./contact.module.css";
import { Col, Row } from "antd";
import LabelInputComponent from "@/component/input/labledinput";
import TextAreas from "@/component/textarea";
import { useFormik } from "formik";
import contactUsValidation from "@/utils/validators/contact-us.validator";
import { submitQuery } from "@/utils/apis/contact-us/contact-us.api";
import { successToast } from "@/component/toasts";
import DefaultLoader from "@/component/loader";
import { useAppContext } from "@/context";
import Link from "next/link";
import { getSiteContent } from "@/utils/apis/site-settings/site-settings.api";
import { IBackendImage } from "@/interfaces/common.interface";
import Image from "next/image";
import { $publicImages } from "@/utils/client";
import { IMAGES } from "@/assets/images";
import { useRouter } from "next/router";
import Head from "next/head";
import { getContactSeo } from "@/utils/apis/minerals/article-seo.api";
import { DefaultCanonical, PageKeywords, metaDescription, metaTitle } from "@/component/seo/DefaultSeo";

function ContactUs({
  content,
  siteBanner = {
    path: "",
    _id: "",
    type: "",
    createdAt: "",
    updatedAt: "",
    __v: 0
  },
  seoData,
}: {
  content: string;
  siteBanner?: IBackendImage;
  seoData: any;
}) {
  console.log("Contact Us SEO Data:", seoData);
  const { user } = useAppContext();
  const router = useRouter();
  const currentPageName = router.pathname.replace(/^\//, "").replace(/-/g, " ");
  const formattedPageName =
    currentPageName.charAt(0).toUpperCase() + currentPageName.slice(1);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      subject: "",
      message: "",
      honeyPot: "",
    },
    validationSchema: contactUsValidation,
    onSubmit: async (values) => {
      try {
        const res = await submitQuery(values);
        console.log(res);
        if (res.data.success) {
          formik.resetForm();
          successToast(
            "Thank you for your inquiry! Our team will follow up with you in 24-48 hours!",
            {
              autoClose: 5000,
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
  });


  const originalTitle = seoData?.title || formattedPageName;
  const seoTitle = [
    originalTitle,
    seoData?.description || "",
    seoData?.keywords || "",
  ]
    .filter(Boolean)
    .join(" | ");

  return (
    <div>
      <DefaultCanonical url={seoData?.canonicalUrl} />
      <PageKeywords keywords={seoData?.keywords} title={originalTitle} description={seoData?.description || ""} />
      <Head>
        <title key="title">{metaTitle(originalTitle, seoData?.title)}</title>
        <meta
          key="description"
          name="description"
          content={metaDescription(seoData?.description || "", seoData?.description)}
        />
        <meta
          key="og:title"
          property="og:title"
          content={seoData?.title || formattedPageName}
        />
        <meta
          key="og:description"
          property="og:description"
          content={metaDescription(seoData?.description || "", seoData?.description)}
        />
        <meta key="og:type" property="og:type" content="website" />
        <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
        <meta
          key="twitter:title"
          name="twitter:title"
          content={seoData?.title || formattedPageName}
        />
        <meta
          key="twitter:description"
          name="twitter:description"
          content={seoData?.description || ""}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Head>
      <Layout>
        {/* <div className={`${styles.banner}`}> </div> */}
        <Image
          src={siteBanner?.path ? $publicImages(siteBanner.path) : IMAGES.Banner}
          alt=""
          width={0}
          height={0}
          sizes="100vw"
          style={{
            width: "100%",
            height: "250px",
            objectFit: "cover",
            margin: 0,
          }}
        />

        <div className="Breadcrumb">
          <div className="main">
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link href={user ? "/dashboard" : "/home"}>
                      {user ? "Dashboard" : "Home"}
                    </Link>
                  ),
                },
                {
                  title: <Link href="/contact-us">Contact Us</Link>,
                },
              ]}
            />
          </div>
        </div>
        <form onSubmit={formik.handleSubmit} className="main">
          {/* hidden honeypot */}
          <input type="text" hidden {...formik.getFieldProps("honeyPot")} />

          <div className={`${styles.head}`}>
            <Row gutter={[12, 12]}>
              <Col md={12}>
                <div className={`${styles.formHeading}`}>
                  <Col md={24}>
                    <LabelInputComponent
                      title="First Name"
                      placeholder="Type here"
                      className={`${styles.Forgot}`}
                      errorText={
                        formik.touched.firstName && formik.errors.firstName
                      }
                      {...formik.getFieldProps("firstName")}
                    />
                  </Col>
                  <Col md={24}>
                    <LabelInputComponent
                      title="Last Name"
                      placeholder="Type here"
                      className={`${styles.Forgot}`}
                      errorText={
                        formik.touched.lastName && formik.errors.lastName
                      }
                      {...formik.getFieldProps("lastName")}
                    />
                  </Col>
                  <Col md={24}>
                    <LabelInputComponent
                      title="Email"
                      placeholder="Enter Your Email"
                      type="email"
                      className={`${styles.Forgot}`}
                      errorText={formik.touched.email && formik.errors.email}
                      {...formik.getFieldProps("email")}
                    />
                  </Col>
                  <Col md={24}>
                    <LabelInputComponent
                      title="Subject"
                      placeholder=""
                      type="text"
                      className={`${styles.Forgot}`}
                      errorText={
                        formik.touched.subject && formik.errors.subject
                      }
                      {...formik.getFieldProps("subject")}
                    />
                  </Col>
                  <Col md={24}>
                    <div className={`${styles.steps}`}>
                      <label
                        htmlFor=""
                        style={{
                          color: "#1F4970",
                          fontSize: "16px",
                          fontWeight: "400",
                          margin: "10px 0px ",
                          marginBottom: "12px",
                          display: "block",
                        }}
                      >
                        Message
                      </label>
                      <TextAreas
                        className={`${styles.forgots}`}
                        value={formik.values.message}
                        onChange={(value) =>
                          formik.setFieldValue("message", value)
                        }
                      />
                    </div>
                  </Col>
                  <div>
                    <button type="submit" className={`${styles.Update}`}>
                      {formik.isSubmitting ? <DefaultLoader /> : "Submit"}
                    </button>
                  </div>
                </div>
              </Col>

              <Col md={12}>
                <div className={`${styles.formContentHeading}`}>
                  <h6 className={`${styles.ContactHeading}`}>Contact Us</h6>
                  <p
                    className={`${styles.Contact}`}
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </Layout>
    </div>
  );
}
export const getServerSideProps = async () => {
  try {
    const [siteContentRes, seoRes] = await Promise.all([
      getSiteContent("contactPageContent"),
      getContactSeo("contactPage").catch(() => ({ data: { success: false } }))
    ]);

    if (!siteContentRes.data.success)
      return { props: { content: null, siteBanner: { path: "" }, seoData: null } };

    const content = siteContentRes.data.data;
    let seoData = null;
    if (seoRes.data.success) {
      const rawSeoData = seoRes.data.data;
      seoData = Array.isArray(rawSeoData) ? rawSeoData[0] : rawSeoData;
    }

    return {
      props: {
        content,
        siteBanner: siteContentRes.data.siteBanner,
        seoData,
      },
    };
  } catch (error) {
    console.error("Error fetching content:", error);
    return {
      props: {
        content: null,
        siteBanner: { path: "" },
        seoData: null,
      },
    };
  }
};

export default ContactUs;
